export default class Dropdown
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-dropdown',
      button: 'data-dropdown-button',
      items: 'data-dropdown-items'
    };
    
    this.dropdowns = document.querySelectorAll(`[${this.settings.main}]`);
    if (!this.dropdowns) return;
    
    return true;
  }
  
  setEvents()
  {
    this.dropdowns.forEach((dropdown) => {
      const button = dropdown.querySelector(`[${this.settings.button}]`);
  
      button.addEventListener('click', () => {
        dropdown.toggleClass('active')
      });
    });
  }
}
